import axios from "axios";

import config from "../config";

const OUTAGE_INFO_URL = config.banner_info_url;

export const getOutageStatus = () => axios.get(OUTAGE_INFO_URL);
